<template>
  <form @submit.prevent="uploadFile" class="upload-form">
    <input type="file" @change="handleFileChange" required class="file-input" />
    <button type="submit" class="upload-button">Загрузить</button>
    <div v-if="uploadProgress !== null" class="progress-container">
      <div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
      <span>{{ uploadProgress }}%</span>
    </div>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </form>
</template>

<script>
import { uploadFileWithProgress } from '../services/api';

export default {
  name: 'UploadForm',
  data() {
    return {
      selectedFile: null,
      uploadProgress: null,
      isUploading: false,
      errorMessage: ''
    };
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.errorMessage = '';
      }
    },
    
    async uploadFile() {
      if (!this.selectedFile || this.isUploading) return;
      
      try {
        this.isUploading = true;
        this.uploadProgress = 0;
        this.errorMessage = '';
        
        const response = await uploadFileWithProgress(
          this.selectedFile,
          (progress) => {
            this.uploadProgress = progress;
          },
          (error) => {
            console.error('Ошибка загрузки:', error);
            this.errorMessage = 'Ошибка загрузки: ' + error.message;
          }
        );
        
        // Успешная загрузка
        this.$emit('file-selected', response);
        this.uploadProgress = null;
        this.isUploading = false;
        
        // Сброс формы
        this.selectedFile = null;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
        
      } catch (error) {
        this.isUploading = false;
        this.uploadProgress = null;
        this.errorMessage = 'Ошибка загрузки файла: ' + (error.message || 'Неизвестная ошибка');
        console.error('Ошибка загрузки файла:', error);
      }
    }
  }
}
</script>

<style scoped>
.upload-form {
  display: flex;
  flex-direction: column;
  gap: 10px; /* Отступ между элементами формы */
  font-family: 'Arial', sans-serif; /* Изменен шрифт */
}
.file-input {
  border: 1px solid #ccc; /* Изменен цвет рамки */
  padding: 10px;
  border-radius: 4px;
}
.upload-button {
  background-color: #4caf50; /* Изменен цвет кнопки */
  color: white;
  border: none;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px; /* Изменен размер шрифта */
}
.upload-button:hover {
  background-color: #45a049; /* Цвет кнопки при наведении */
}
.progress-container {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 4px;
  overflow: hidden;
}
.progress-bar {
  height: 10px;
  background-color: #4caf50;
  transition: width 0.2s;
}
.error-message {
  color: red;
  font-size: 0.8em;
  margin-top: 5px;
}
</style> 